module.exports = __webpack_public_path__ + "media/locales/_en-320bf846.png";